const configBoardTemplate = {
    notice: {
        listLayout: 'BoardListDefaultLayout',
        filterLayout: 'BoardFilterDefaultLayout',
        paginationLayout: 'PaginationDefaultLayout',
    },
    noticeCreate: {
        writeLayouts: ['BoardWriteDefaultLayout'],
    },
    noticeUpdate: {
        writeLayouts: ['BoardWriteDefaultLayout'],
    },
    faq: {
        listLayout: 'BoardListFaqLayout',
        filterLayout: 'BoardFilterFaqLayout',
        paginationLayout: 'PaginationDefaultLayout',
    },
    faqCreate: {
        writeLayouts: ['BoardWriteFaqLayout'],
    },
    faqUpdate: {
        writeLayouts: ['BoardWriteFaqLayout'],
    },
    category:{
        writeLayouts: ['BoardWriteCategoryLayout'],
    },
    qna: {
        listLayout: 'BoardListQnaLayout',
        filterLayout: 'BoardFilterQnaLayout',
        paginationLayout: 'PaginationDefaultLayout',
    },
    qnaUpdate: {
        writeLayouts: ['BoardWriteQnaLayout'],
    },

}

export default {
    methods: {
        returnBoardTemplateConfig(type) {
            return configBoardTemplate[type];
        }
    }
}